// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2xfki","choiceBoxes":"toolbarselects_choiceBoxes__1_B6z","simpleField":"toolbarselects_simpleField__RxQDP"};